const dateEpoch = (value) => {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value))
        return NaN;
    const epoch = Date.parse(`${value}T00:00:00Z`);
    return Number.isFinite(epoch) && new Date(epoch).toISOString().slice(0, 10) === value ? epoch : NaN;
};
/** Move all date fields by one calendar offset, preserving times and duration. */
export function moveTravelItemDates(values, dateKeys, day, rangeRole = 'single') {
    const target = dateEpoch(day.dateStart);
    if (!Number.isFinite(target))
        return values;
    const dates = dateKeys.filter(key => Number.isFinite(dateEpoch(values[key])));
    const preferred = rangeRole === 'end'
        ? ['arrive_date', 'checkout_date', 'end_date', 'date_finish']
        : ['depart_date', 'checkin_date', 'start_date', 'visit_date', 'when_date', 'date_start'];
    const key = preferred.find(candidate => dates.includes(candidate)) || dates[0];
    if (!key)
        return values;
    const anchor = dateEpoch(values[key]);
    const finish = dateEpoch(day.dateFinish);
    if (target <= anchor && anchor <= (Number.isFinite(finish) ? finish : target))
        return values;
    const delta = target - anchor;
    const shifted = { ...values };
    for (const key of dates)
        shifted[key] = new Date(dateEpoch(values[key]) + delta).toISOString().slice(0, 10);
    return shifted;
}
